var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.66669C11 6.1144 10.5523 5.66669 10 5.66669C9.44774 5.66669 9.00002 6.1144 9.00002 6.66669H11ZM9.00002 10C9.00002 10.5523 9.44774 11 10 11C10.5523 11 11 10.5523 11 10H9.00002ZM10 12.3334C9.44774 12.3334 9.00002 12.7811 9.00002 13.3334C9.00002 13.8856 9.44774 14.3334 10 14.3334V12.3334ZM10.0084 14.3334C10.5606 14.3334 11.0084 13.8856 11.0084 13.3334C11.0084 12.7811 10.5606 12.3334 10.0084 12.3334V14.3334ZM17.3334 10C17.3334 14.0501 14.0501 17.3334 10 17.3334V19.3334C15.1547 19.3334 19.3334 15.1547 19.3334 10H17.3334ZM10 17.3334C5.94993 17.3334 2.66669 14.0501 2.66669 10H0.666687C0.666687 15.1547 4.84536 19.3334 10 19.3334V17.3334ZM2.66669 10C2.66669 5.94993 5.94993 2.66669 10 2.66669V0.666687C4.84536 0.666687 0.666687 4.84536 0.666687 10H2.66669ZM10 2.66669C14.0501 2.66669 17.3334 5.94993 17.3334 10H19.3334C19.3334 4.84536 15.1547 0.666687 10 0.666687V2.66669ZM9.00002 6.66669V10H11V6.66669H9.00002ZM10 14.3334H10.0084V12.3334H10V14.3334Z",
    fill: "#B0B058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2b46c26175c49cfd24a540a2c26e6a8f.svg";
export { ForwardRef as ReactComponent };